import CollectionApi from 'client/api/v2/CollectionApi';

class OrganizationInvoiceApi extends CollectionApi {
  constructor() {
    super('/api/v2/organizations/invoices', {
      skip: 0,
      limit: 30,
      sort: '-dueDate',
    });
  }

  // eslint-disable-next-line class-methods-use-this
  getInvoiceUrl(invoiceId) {
    return `/api/v2/organizations/invoices/${invoiceId}`;
  }
}

export default new OrganizationInvoiceApi();
